import C5BaseDAO from "./C5BaseDAO";
import ProdutoModel from "../../model/ProdutoModel";

class C5ProdutoDAO extends C5BaseDAO {
  private static instance: C5ProdutoDAO;
  private endpoint = `${super.getBasePath()}`;
  private cacheEndpoint = `${super.getAPIPath()}/api/Product`;

  private constructor() {
    super();
  }

  public static getInstance(): C5ProdutoDAO {
    if (!C5ProdutoDAO.instance) {
      C5ProdutoDAO.instance = new C5ProdutoDAO();
    }
    return C5ProdutoDAO.instance;
  }

  public async getById(
    produtoId: string,
    lojaId: string | null
  ): Promise<ProdutoModel | null> {
    if (lojaId) {
      return this.get(
        `REQ_C5_PRODUTO_${produtoId}`,
        `${this.cacheEndpoint}/ProductDetail?id=${produtoId}&StoreID=${lojaId}`
      ).then((r: any) => ProdutoModel.toModel(r.data.product));
    } else {
      throw new Error("Produto não encontrado");
    }
  }

  public async getBuscaProdutos(
    q: string,
    t: string,
    lojaId: string | null
  ): Promise<ProdutoModel[]> {
    if (lojaId) {
      const endpoint: string = `${this.endpoint}/Search?SearchWord=${encodeURIComponent(q)}&StoreID=${lojaId}&pageCount=200`;
      return this.get(
        `REQ_C5_BUSCA_PRODUTO_LOJA_${q}_${lojaId}`,
        endpoint
      ).then((r: any) => {
        return r.data.Products ? r.data.Products.filter((p: any) =>
            ProdutoModel.temEstoque(p)
        ).map((p: any) => ProdutoModel.toModelByCategoriaProduto(p, t)) : []
      });
    } else {
      throw new Error("Produto não encontrado");
    }
  }
}

export default C5ProdutoDAO;
